import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '@store/store'

const getRoot = (state: RootState) => state.order

export const list = createSelector(getRoot, (state) => state.list)
export const pagemeta = createSelector(getRoot, (state) => state.meta)
export const detail = createSelector(getRoot, (state) => state.detail)
